<template>
  <div>
    <el-card>
      <div slot="header" class="font-bold">资源管理</div>
      <el-form :inline="true" size="small">
        <el-form-item label="关键词">
          <el-input v-model="keyword" placeholder="搜索标题" clearable @clear="fetch" @keyup.enter.native="fetch" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="status" placeholder="全部" clearable @change="fetch">
            <el-option label="已发布" value="published" /><el-option label="已下架" value="removed" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetch">搜索</el-button></el-form-item>
      </el-form>
      <el-table :data="list" v-loading="loading" size="small">
        <el-table-column prop="title" label="标题" />
        <el-table-column prop="bloggerName" label="博主" width="120" />
        <el-table-column label="付费" width="70">
          <template slot-scope="{row}">{{ row.isPaid ? '¥'+row.price : '免费' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="{row}">
            <el-tag :type="row.status==='published'?'success':'warning'" size="small">{{ row.status==='published'?'已上架':'已下架' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发布时间" width="160">
          <template slot-scope="{row}">{{ formatDate(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{row}">
            <el-button v-if="row.status === 'published'" type="danger" size="mini" @click="forceRemove(row)">强制下架</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:16px;text-align:right" background layout="total,prev,pager,next"
        :total="total" :page-size="size" :current-page.sync="page" @current-change="fetch" />
    </el-card>
  </div>
</template>

<script>
import { adminApi, resourceApi } from '../api';

export default {
  data() {
    return { list: [], page: 1, size: 10, total: 0, loading: false, keyword: '', status: '' };
  },
  created() { this.fetch(); },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await adminApi.listResources({ page: this.page, size: this.size, keyword: this.keyword || undefined, status: this.status || undefined });
      this.list = res.data.list;
      this.total = res.data.total;
      this.loading = false;
    },
    async forceRemove(row) {
      try {
        await this.$confirm('确定要强制下架「' + row.title + '」吗？', '确认', { type: 'warning' });
        await resourceApi.forceRemove(row.id);
        this.$message.success('已强制下架');
        this.fetch();
      } catch (e) { /* canceled */ }
    },
    formatDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleString('zh-CN');
    }
  }
};
</script>
